import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import IS_BROWSER from '@picsart/rc/isBrowser';
import { get, getApiUrl } from '../httpService/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetchFeaturesAvailability = function fetchFeaturesAvailability(features, accessToken) {
  return get("".concat(getApiUrl(), "/guard/availability?features=").concat(features.toString()), {
    headers: _objectSpread({
      platform: 'website'
    }, authorizationHeader(accessToken))
  }).then(function (resp) {
    // For dev. Can be removed after implementation.
    var updatedResp = resp;
    if (IS_BROWSER && resp.status === 'success') {
      var urlParams = new URLSearchParams(window.location.search);
      var tiersParam = urlParams.get('tiersEnabled');
      var creditsParam = urlParams.get('creditsEnabled');
      if (tiersParam) {
        updatedResp.response.tier = {
          is_available: tiersParam === '1'
        };
      }
      if (creditsParam) {
        updatedResp.response.credit = {
          is_available: creditsParam === '1'
        };
      }
    }
    return updatedResp;
  });
};
var featuresService = {
  fetchFeaturesAvailability: fetchFeaturesAvailability
};

export { featuresService as default, fetchFeaturesAvailability };
//# sourceMappingURL=index.js.map
